import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import SvgIcon from "../../../../../parts/SvgIcon";

export const CreateNewFoodModal = () => {
  const { t } = useTranslation("coaching-portal");
  /**
   * Function to redirect to create meal o create food modal
   */
  const handleRedirect = (destination) => {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        "modal[type]": destination,
      },
    });
  };

  return (
    <Modal className="create-new-food-modal" title={t("editMealPlan.createNewFoodModal.title")} backButton={true}>
      <div className="body">

        <button
          onClick={() => {
            handleRedirect("handle-meal-planner-food");
          }}
        >
          <div className="main-button-container">
            <div className="img-button">
              <SvgIcon src="/img/new-icons/meal.svg" noFilterOnLight={false} />
            </div>
            <div className="info-button">
              <span>{t("editMealPlan.createNewFoodModal.createFood")}</span>
              <span className="opacity-70 text-[0.75rem]">
                {t("editMealPlan.createNewFoodModal.createFoodDescription")}
              </span>
            </div>
          </div>
          <div className="arrow">
            <SvgIcon
              src="/img/new-icons/arrow-right.svg"
              alt="right"
              noFilterOnLight={false}
            />
          </div>
        </button>
        <button
          onClick={() => {
            handleRedirect("build-meal");
          }}
        >
          <div className="main-button-container">
            <div className="img-button">
              <SvgIcon src="/img/new-icons/food.svg" noFilterOnLight={false} />
            </div>
            <div className="info-button">
              <span>{t("editMealPlan.createNewFoodModal.createMeal")}</span>
              <span className="opacity-70 text-[0.75rem]">
                {t("editMealPlan.createNewFoodModal.createMealDescription")}
              </span>
            </div>
          </div>
          <div className="arrow">
            <SvgIcon
              src="/img/new-icons/arrow-right.svg"
              alt="right"
              noFilterOnLight={false}
            />
          </div>
        </button>
      </div>
    </Modal>
  );
};